import { User, navList } from "@/models/common-interface/common.interface";
import { loginApi } from "@/providers/apis/login";
import { utils } from "@/utils/utils";
import Vue from "vue";
import Component from "vue-class-component";
import { appConfigService } from "@/providers/services/app/app-config";
import { notAcceptedEmailApi } from "@/providers/apis/not-accepted-email-form";
import NotificationBellComponent from "../notification-bell/notification-bell.component.vue";
import EmailModalPopupComponent from "../email-modal-popup/email-modal-popup.component.vue";

@Component({
  components: {
    NotificationBellComponent,
    EmailModalPopupComponent,
  },
})
export default class UserDasboardComponent extends Vue {
  public currentRoute = "";
  public navListsData: navList = [];
  public isCollapse = false;
  public isMenuEnabled = false;
  public isScroll = false;
  public userDetails: User = {} as User;
  public toogleStatus = false;
  public userDashboard = false;
  public profileDetail: any;
  public S3Path = "";
  public isAdmin: any;
  public notificationMails: any[] = [];
  public notificationEmailData: any = null;
  public notificationMail: any = null;

  public mounted() {
    this.loadNotifications();
    this.userDetails = utils.getUserDetails();
    this.isAdmin = localStorage.getItem("impersonateId");
    if (this.userDetails.roles === null || !this.userDetails.roles) {
      this.userDashboard = true;
    } else {
      this.userDashboard = false;
    }
    if (utils.checkIsMobileView() || utils.checkIsTabView()) {
      this.isMenuEnabled = true;
    } else {
      this.isMenuEnabled = false;
    }
    this.profileDetail = utils.getProfileDetails();
    this.S3Path = appConfigService.getS3FilesPathUrl();
    this.currentRoute = this.$route.path.split("/")[1];
    this.navListsData =
      this.currentRoute === "user-dashboard"
        ? [
            {
              name: "Home",
              icon_class: "user_home",
              url: "/user-dashboard/home",
              visible: true,
            },
            {
              name: "My Applications",
              icon_class: "my-application",
              url: "/user-dashboard/my-application",
              visible: true,
            },
            {
              name: "Continuing Education",
              icon_class: "education",
              url: "/user-dashboard/education",
              visible: true,
            },
            {
              name: "Documents Library",
              icon_class: "document",
              url: "/user-dashboard/document-library",
              visible: true,
            },
            {
              name: "Conversations",
              icon_class: "conversations",
              url: "/user-dashboard/conversations",
              visible: true,
            },
          ]
        : [
            {
              name: "Home",
              icon_class: "home",
              url: "/reviewer-dashboard/home",
              visible: true,
            },
            {
              name: "Training",
              icon_class: "training",
              url: "/reviewer-dashboard/training",
              visible: true,
            },
            {
              name: "Certification",
              icon_class: "certification",
              url: "/reviewer-dashboard/certification",
              visible: true,
            },
            {
              name: "Renewal",
              icon_class: "renewal",
              url: "/reviewer-dashboard/renewal",
              visible: true,
            },
            {
              name: "Peers",
              icon_class: "peers",
              url: "/reviewer-dashboard/peers",
              visible: true,
            },
            {
              name: "Reports",
              icon_class: "reports",
              url: "/reviewer-dashboard/reports",
              visible: true,
            },
            {
              name: "Complaints",
              icon_class: "complaints",
              url: "/reviewer-dashboard/complaints",
              visible: true,
            },
          ];
  }

  public updated() {
    window.document.onclick = (event) => {
      if (this.toogleStatus) {
        const getFilterElement = document.getElementsByClassName(
          "logo-and-details-container"
        )[0];
        if (
          getFilterElement &&
          !getFilterElement.contains(event.target as Node)
        ) {
          this.toogleStatus = !this.toogleStatus;
        }
      }
    };
    window.document.onscroll = () => {
      const navbar = document.getElementById("main-container");
      if (navbar) {
        if (window.scrollY > 55) {
          this.isScroll = true;
        } else if (window.scrollY < 55) {
          this.isScroll = false;
        }
      }
    };
    if (
      this.$route.path.split("/").length > 3 ||
      this.$route.path === "/reviewer-dashboard/peers-preview"
    ) {
      this.isCollapse = true;
    } else {
      this.isCollapse = false;
    }
  }

  public logout() {
    loginApi
      .logOut()
      .then(() => {
        utils.deleteLocalStorage();
        this.$router.push("/home").catch(() => {
          //todo
        });
      })
      .catch((error) => {
        return error;
      });
  }

  public changePassword() {
    this.$router.push({
      path: "/login",
      query: {
        loginType: "changePassword",
      },
    });
  }
  public backToAdmin() {
    const accessToken: any = localStorage.getItem("admin_access_token");
    const userDetail: any = localStorage.getItem("admin_user_details");
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("user_details", userDetail);
    localStorage.setItem("profileData", userDetail);
    this.$router.push({
      path: `/reviewer-dashboard/peers-preview`,
      query: {
        id: localStorage.getItem("impersonateId"),
      },
    });
    localStorage.removeItem("impersonateId");
    localStorage.removeItem("partTwoCertificationPayload");
    localStorage.removeItem("renewalPayLoadData");
    window.location.reload();
  }

  /** Bell feed. Reviewers only - applicants have no inbound reviewer mail. */
  public async loadNotifications() {
    if (!this.hasReviewerRole || this.isImpersonating) {
      return;
    }
    this.notificationMails = await notAcceptedEmailApi.getUnreadMails();
  }

  /**
   * Opens the thread in the email popup, rather than routing to the bulk
   * campaigns page - the wrong place entirely for replying to one peer.
   */
  public onNotificationOpen(mail: any) {
    if (!mail) {
      return;
    }
    this.notificationMail = mail;
    // The popup reads its recipient off `item`; applicationName is left blank
    // so it does not try to dig an address out of a nested application record
    // the notification feed never carries.
    this.notificationEmailData = {
      item: {
        id: mail.applicationId,
        userId: mail.userId,
        email: mail.latestSenderEmail,
        applicationName: "",
        data: {},
      },
    };
    this.$nextTick(() => {
      this.$bvModal.show("notification-email-modal");
    });
  }

  /**
   * The bell belongs on the dashboard and the list screens only.
   *
   * It floats over the top-right of the page, which is fine above a table but
   * lands on the content of a record once you open one. Every detail view is
   * reached with a route param, so the param is the test, plus the peers
   * preview that carries none.
   */
  public get showNotificationBell(): boolean {
    const route = this.$route;
    // Reviewer screens only: the peer portal shares this shell, and an
    // applicant has no reviewer mailbox behind the bell.
    if (`${route.path || ""}`.split("/")[1] !== "reviewer-dashboard") {
      return false;
    }
    // While impersonating, the reviewer is standing in someone else's portal;
    // their own notifications do not belong on that screen.
    if (this.isImpersonating) {
      return false;
    }
    if (!this.hasReviewerRole) {
      return false;
    }
    if (Object.keys(route.params || {}).length) {
      return false;
    }
    return !`${route.name || ""}`.includes("preview");
  }

  private get isImpersonating(): boolean {
    try {
      return !!localStorage.getItem("impersonateId");
    } catch (error) {
      return false;
    }
  }

  private get hasReviewerRole(): boolean {
    const details = utils.getUserDetails();
    return !!(details && details.roles);
  }

  /** Seeds the reply subject; empty until a notification is opened. */
  public get notificationSubject(): string {
    return this.notificationMail ? this.notificationMail.latestSubject : "";
  }

  /**
   * A reply acknowledges the thread, so it leaves the feed - but the popup
   * stays open on the conversation, which now carries that reply.
   */
  public onNotificationReplied() {
    const mail = this.notificationMail;
    if (!mail) {
      return;
    }
    this.markNotificationRead(mail);
  }

  /** Marked read explicitly: the popup closes with it. */
  public onNotificationHandled() {
    const mail = this.notificationMail;
    this.notificationEmailData = null;
    this.notificationMail = null;
    if (!mail) {
      return;
    }
    this.markNotificationRead(mail);
  }

  /**
   * Tells the server the thread has been read and drops it from the feed.
   *
   * Called for both a reply and an explicit Mark as Read rather than leaning
   * on opening the row having done it: a reviewer can reach either from a
   * popup that was already open, and the badge should not survive that.
   *
   * Scoped the way the read route expects - applicationId, else userId, else
   * the address the thread is keyed on.
   */
  private markNotificationRead(mail: any) {
    this.notificationMails = this.notificationMails.filter((row: any) => {
      return row.applicationId !== mail.applicationId;
    });
    let scope = "";
    if (mail.applicationId) {
      scope = `applicationId=${mail.applicationId}`;
    } else if (mail.userId) {
      scope = `userId=${mail.userId}`;
    } else if (mail.emailId) {
      scope = `email=${encodeURIComponent(mail.emailId)}`;
    }
    if (scope) {
      notAcceptedEmailApi.markEmailRead(scope);
    }
  }
}
